import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { setLogoutState } from "api-store/user-data/slice";// Adjust the import path

export const useLogout = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const logout = () => {
    // Clear user data from Redux
    dispatch(setLogoutState());

    // Log out with MSAL
    instance.logoutRedirect().catch((e: any) => {
      console.log(e);
    });
  };

  return logout;
};
